interface Props {
    year: number;
}
const EmptyTableContent: React.FC<Props> = ({year}) => {
    return (
        <p>No data available for {year}</p>
    )
}

export default EmptyTableContent;